import React from "react";

interface Props {
  headerText: string;
  productLink: string;
}

const YouMayAlsoNeedHeader = ({ headerText, productLink }: Props) => {
  return (
    <div className="page-header-container">
      <h1 className="page-header">{`Products You May Need For ${headerText}`}</h1>
      {productLink && (
        <h2 className="page-header-2">
          <a href={productLink || ""}>Back to Product Page</a>
        </h2>
      )}
    </div>
  );
};
export default YouMayAlsoNeedHeader;
